import { BaseApi } from "../../utils/BaseApi";
import { Customer } from "../models/customers/CustomerModel";
import { HttpMethodEnum } from "../models/HttpMethodEnum";

export class CustomerApi extends BaseApi {
  private static instance: CustomerApi;

  public static get(): CustomerApi {
    if (!this.instance) {
      this.instance = new CustomerApi();
    }
    return this.instance;
  }

  public getAllCustomers = BaseApi.createEndpoint<Customer[], null>(
    HttpMethodEnum.GET,
    "/business/customer/all"
  );

  public updateOrCreateCustomer = BaseApi.createEndpoint<
    null,
    { customer: Customer }
  >(HttpMethodEnum.POST, "/business/customer/update");

  public deleteCustomer = BaseApi.createEndpoint<null, { customer: Customer }>(
    HttpMethodEnum.DELETE,
    "/business/customer/update"
  );
}

export const customerApi = CustomerApi.get();
